import React, { PropsWithChildren } from "react";
import styles from "./Section.module.scss";
import cn from "classnames";
import { SectionSubComponents, SectionProps } from "./Section.props";

import { SectionTitle } from "./SectionTitle";
import { SectionHeader } from "./SectionHeader";
import { SectionBody } from "./SectionBody";
import { SectionDetails } from "./SectionDetails";

/**
 * The section component.
 */
/**
 * @deprecated
 */
export const Section: React.FC<PropsWithChildren<SectionProps>> & SectionSubComponents = ({
  children,
  header,
  id,
  testId,
  className,
}: PropsWithChildren<SectionProps>) => {
  const sectionClasses = cn(styles.Section, "section", className);

  return (
    <div className={sectionClasses} id={id} data-testid={testId ? `test__${testId}-section` : undefined}>
      <HeaderComponent header={header} />
      <SectionBody>{children}</SectionBody>
    </div>
  );
};

Section.Title = SectionTitle;
Section.Header = SectionHeader;
Section.Details = SectionDetails;

interface HeaderProps {
  header: string | React.ReactNode;
}

const HeaderComponent = (props: HeaderProps): JSX.Element => {
  const { header } = props;

  if (typeof header === "string") {
    return (
      <SectionHeader>
        <SectionTitle>{header}</SectionTitle>
      </SectionHeader>
    );
  }

  return <>{header}</>;
};
